import React, { useState, useEffect, useRef } from "react";
import 'react-nice-dates/build/style.css'
import "../../../RdssForms/rdssforms.scss";
import Modalbox from "../../DashboardComponents/ModalBox/ModalBox";
import { Link } from "react-router-dom";
import { GrDownload, GrUpload } from "react-icons/gr";

// Images
import FieldComponent from "../../../FieldComponent";
import MyTooltip from "./MyTooltip";

const Pq6 = (props: any) => {
    const [fields, setFields] = useState<any[]>([]);
    const [year, setYear] = useState<any>(props.year);
    useEffect(() => {
        setFields(props.fields)
    }, [props.fields]);
    const [roleid, setRoleid] = useState<any>(0);
    useEffect(() => {
        setRoleid(sessionStorage.getItem('roleid'))
    }, [roleid]);

    useEffect(() => {
        setYear(props.year);
    }, [props.year]);

    return (
        <>
        {/* PQ-6 */}
        {fields.length ?
            <>
            <tr>
                <td colSpan={5}></td>
            </tr>
            <tr>
                <td colSpan={5} className="blankPara">
                    <div className="d-flex justify-content-between align-item-center">
                        <div className="d-flex align-items-center w-100">
                            <p className="mb-0 ps-2 fw-medium pe-3">PQ-6 : Installation of prepaid meters in Government offices <b>*</b></p>
                            {roleid == 5 || roleid == 6 || props.iscompletedsubmittedstatus == 1 ?
                                <>
                                {props.submittedStatus == 1 ?
                                    <>
                                    <select defaultValue={fields[218] && fields[218].value ? fields[218].value : ''} name="formdata[pqsop_details][pq6_nodal]" id="pqsop_details_pq6_nodal" className="form-select text-start">
                                        <option value="">Select</option>
                                        <option value="Compliant">Compliant</option>
                                        <option value="Partial Compliant">Partial Compliant</option>
                                        <option value="Non-Compliant">Non-Compliant</option>
                                        <option value="Compliant with Delay">Compliant with Delay</option>
                                    </select>

                                    <div className="col-md-0">
                                        {/* <p className="mb-0 ps-2 fw-medium pe-3">Remarks</p> */}
                                        <div className="form-group text">
                                            <div className="form-field">
                                                <input autoComplete="off" className="form-control" type="text" name="formdata[pqsop_details][pq6_remarks_nodal]" id="pqsop_details_pq6_remarks_nodal" defaultValue={fields[233] && fields[233].value ? fields[233].value : ''} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fileUpload position-relative text-center">
                                        <div className="dowupEqule">
                                            <input type="file" autoComplete="off" className="form-control" name="formdata[pqsop_details][pq6_document_nodal]" id="pqsop_details_pq6_document_nodal" />
                                            <div className="customUpload justify-content-center flex-wrap">
                                                <span> <GrUpload /> </span>
                                                {/* <span>.PDF, .Docx, .XLS</span> */}
                                            </div>
                                        </div>
                                        {fields[248].value != '' ?
                                            <a href={fields[248].value} title={fields[248].value} className="viewupload" target="_blank"><GrDownload /></a>
                                            : null
                                        }
                                    </div>

                                    </>
                                    :
                                    <>

                                    {fields[218].value != '' ?
                                        <div className="col-md-0">
                                            <div className="form-group select">
                                                <div className="form-field">
                                                    <div className="view-field text-start">
                                                        {fields[218] && fields[218].value ? fields[218].value : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                    }

                                    {/* {fields[233].value != '' ? */}
                                    <div className={"view-field text-start"}> {fields[233] && fields[233].value ? fields[233].value : ''}</div>
                                    {/* : null
                                            } */}

                                    {fields[248].value != '' ?
                                        <div className="view-field text-center">
                                            <a href={fields[248] && fields[248].value ? fields[248].value : ''} title={fields[248] && fields[248].value ? fields[248].value : ''} className="viewupload" target="_blank">
                                                <span><GrDownload /></span>
                                            </a>
                                        </div>
                                        : null
                                    }

                                    </>
                                }
                                </> : null
                            }


                        </div>
                        <div className={props.remove}>
                            <MyTooltip placement="left">
                                <ul>
                                    <li>Progress commensurate to commitment in putting Govt. Offices on prepaid meters</li>
                                    <li>Documentary Evidence: Copy of NIT</li>
                                </ul>
                            </MyTooltip>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>Total Govt. Dept. Offices (Nos.)</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[114].key} field={fields[114]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[115].key} field={fields[115]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Govt. offices identified as not feasible for prepaid metering (Nos.)</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[116].key} field={fields[116]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[117].key} field={fields[117]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Balance Govt. Offices to be migrated to prepaid metering (Nos.)</td>

                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[118].key} field={fields[118]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[119].key} field={fields[119]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>Target set to install prepaid meters in Govt. Offices by FY {year - 1}</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[120].key} field={fields[120]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[121].key} field={fields[121]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td rowSpan={2}>Target achieved to install prepaid meters in Govt. Offices by FY {year - 1}</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[122].key} field={fields[122]} />
                </td>
                <td rowSpan={2}>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[123].key} field={fields[123]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[124].key} field={fields[124]} />
                </td>
            </tr>
            <tr>
                <td>Target set to install prepaid meters in Govt. Offices by FY {year}</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[125].key} field={fields[125]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[207].key} field={fields[207]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td rowSpan={2}>Target achieved to install prepaid meters in Govt. Offices by FY {year}</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[208].key} field={fields[208]} />
                </td>
                <td rowSpan={2}>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[209].key} field={fields[209]} />
                </td>
                <td></td>
                <td></td>
            </tr>
            <tr>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[210].key} field={fields[210]} />
                </td>
            </tr>

            <tr className="borderThik">
                <td>Remarks</td>
                <td colSpan={4}>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[211].key} field={fields[211]} />
                </td>
            </tr>
            </>
            : null
        }
        </>
    );
};

export default Pq6;